import { callAPI } from '../network';

/* AbsencePermissions */
export async function getRequestAbsencePermissions(params){
    const data = await callAPI(
        null, 
        `EmployeeAbsencePermissions?${params}`, 'get');
    return data || [];
}

/* AbsencePermissions admin */
// export async function getRequestAbsencePermissionsAdmin(model) {
//     model.CompanyId = parseInt(model.CompanyId, 10) || 0; // Asegurar que sea un número
    

//     const data = await callAPI(
//         model, 
        
//         'EmployeeAbsencePermissions/GetEmployeeAbsencePermissionsAdmin', 'post'
//     );

//     return data || [];
// }

export async function getRequestAbsencePermissionsAdmin (model){
  
    const data = await callAPI(
                         model, 
                         'EmployeeAbsencePermissions/GetEmployeeAbsencePermissionsAdmin', 'post');
    return data || [ ];
 }


export async function sendNewAbsencePermissions(params){
    const data = await callAPI(
                        params, 
                        'EmployeeAbsencePermissions', 'post');
    return data || [];
}

export async function sendUpdateAbsencePermissions(params){
    const data = await callAPI(
                        params, 
                        'EmployeeAbsencePermissions', 'put');
    return data || [];
}

export async function getEmployeeAbsencePermissionsConsult(params){
    const data = await callAPI(
                        null, 
                        `EmployeeAbsencePermissions/GetEmployeeAbsencePermissionsConsult${params}`, 'get');
    return data || [];
}

export async function getEmployeeUsability(params){
    const data = await callAPI(
                        null, 
                        `Usability${params}`, 'get');
    return data || [];
}

